import React, { useRef } from 'react'
import { joinClasses } from 'utils/joinClasses'
import { Skeleton } from '@frontend/design_system'
import { AutocompleteDropdownProps } from './types'
import { AutocompleteList } from '../AutocompleteList'
import styles from './styles.module.scss'

export const AutocompleteDropdown = ({
  items,
  selectedValue,
  onChange,
  noSpaceForError,
  search,
  loading,
  notFoundTitle,
}: AutocompleteDropdownProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={dropdownRef}
      className={joinClasses(styles['autocomplete-dropdown'], [
        styles['without-error'],
        noSpaceForError,
      ])}
    >
      {loading ? (
        <div className={styles.skeleton}>
          <Skeleton.Spinner size={36} />
        </div>
      ) : (
        <AutocompleteList
          items={items}
          selectedValue={selectedValue}
          onChange={onChange}
          containerRef={dropdownRef}
          search={search}
          notFoundTitle={notFoundTitle}
        />
      )}
    </div>
  )
}
